import {
  type ICouponRepository,
  type ICreateWagerUseCase,
  type IWagerClientService,
  NotFoundError,
} from '../../../domain/entry.js';

/**
 * Use case for create a wager based a coupon.
 *
 * @param wagerClientService Wager service dependency
 * @param couponRepository Coupon repository dependency
 * @returns Use case executor for creating wagers
 */
export function createWagerUseCase(
  wagerClientService: IWagerClientService,
  couponRepository: ICouponRepository
): ICreateWagerUseCase {
  return {
    execute: async ({
      wallets,
      couponId,
      couponIndices,
      showDialog,
      paymentContext,
    }): ReturnType<ICreateWagerUseCase['execute']> => {
      const couponsPromises = couponIndices.map(async (couponIndex) => {
        const coupon = await couponRepository.getCoupon({ couponId, couponIndex });

        if (!coupon) {
          throw new NotFoundError(`Coupon not found with id: ${couponId}, index: ${couponIndex}`);
        }

        return coupon;
      });

      const coupons = await Promise.all(couponsPromises);

      const wagerPaymentResponse = await wagerClientService.createWagerAsync(coupons, {
        wallets,
        couponIndices,
        showDialog,
        paymentContext,
      });

      return wagerPaymentResponse;
    },
  };
}
